import { createContext, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { storage } from "../Utils/storageService";
// import { getallRoles } from "../Redux/actions/getroles";
const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  // const dispatch = useDispatch();
  const CurrentUser = useSelector((state) => state.GetAllRole);
  // const token = storage.getToken();
  const [session, setSessionState] = useState({
    OpeningYear: null,
    UserName: null,
    ProjectId: null,
    LoginId: null,
    ProjectName: null,
    ProjectOwner: null,
  });
  const projectId = Number(storage.getProjectId());
  const [loading, setLoading] = useState(false);

  const setSession = (data) => {
    setSessionState(data);
  };

  // useEffect(() => {
  //   if (token) {
  //     setLoading(true);
  //     dispatch(getallRoles());
  //   }
  // }, [dispatch, token]);
  useEffect(() => {
    if (CurrentUser?.data) {
      let matchedProject = {};
      if (projectId !== 0) {
        matchedProject = CurrentUser?.data?.Projects?.find((p) => p.ProjectId === projectId);
      } else {
        matchedProject = null;
      }
      const openingYear = CurrentUser?.data?.OpeningYear
        ? CurrentUser.data.OpeningYear.split("T")[0]
        : "";
      setSessionState({
        UserName: CurrentUser?.data?.FullName,
        Email: CurrentUser?.data?.UserName,
        IsAdmin: CurrentUser?.data?.IsAdmin,
        CreateInBoth: CurrentUser?.data?.BothSystemsAccess,
        AllowErpSystem: CurrentUser?.data?.AllowErpSystem,
        AllowCrmSystem: CurrentUser?.data?.AllowCrmSystem,
        IsAiEnabled: CurrentUser?.data?.IsAiEnabled,
        LoginId: CurrentUser?.data?.LoginId,
        ProjectOwner: matchedProject?.ProjectOwner || null,
        ProjectName: matchedProject?.ProjectName || null,
        ProjectId: matchedProject?.ProjectId || null,
        OpeningYear: openingYear,
        BusinessId: CurrentUser?.data?.BusinessId || null,
      });
    }
  }, [CurrentUser, projectId]);
  return (
    <SessionContext.Provider
      value={{ session, setSession, loading, setLoading, rolesdata: CurrentUser }}
    >
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => {
  const ctx = useContext(SessionContext);
  if (!ctx) {
    throw new Error("useSession must be used within a SessionProvider");
  }
  return ctx;
};

export { SessionContext };
SessionProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

// import { createContext, useContext, useState, useEffect } from "react";
// import PropTypes from "prop-types";
// import { useSelector } from "react-redux";
// // import { getallRoles } from "../Redux/actions/getroles";
// const SessionContext = createContext();

// export const SessionProvider = ({ children }) => {
//   // const dispatch = useDispatch();
//   const CurrentUser = useSelector((state) => state.GetAllRole);
//   // const token = localStorage.getItem("token");
//   const [session, setSessionState] = useState({
//     OpeningYear: null,
//     UserName: null,
//     ProjectId: null,
//     LoginId: null,
//     ProjectName: null,
//     ProjectOwner: null,
//   });
//   const projectId = Number(localStorage.getItem("ProjectId"));
//   const [loading, setLoading] = useState(false);

//   const setSession = (data) => {
//     setSessionState(data);
//   };

//   // useEffect(() => {
//   //   if (token) {
//   //     setLoading(true);

//   //     dispatch(getallRoles());
//   //   }
//   // }, [dispatch, token]);

//   useEffect(() => {
//     if (CurrentUser?.data) {
//       let matchedProject = {};
//       if (projectId !== 0) {
//         matchedProject = CurrentUser?.data?.Projects?.find(
//           (p) => p.ProjectId === projectId
//         );
//       } else {
//         matchedProject = null;
//       }
//       const openingYear = CurrentUser?.data?.OpeningYear
//         ? CurrentUser.data.OpeningYear.split("T")[0]
//         : "";
//       setSessionState({
//         UserName: CurrentUser?.data?.FullName,
//         IsAdmin: CurrentUser?.data?.IsAdmin,
//         IsAiEnabled: CurrentUser?.data?.IsAiEnabled,
//         LoginId: CurrentUser?.data?.LoginId,
//         ProjectOwner: matchedProject?.ProjectOwner || null,
//         ProjectName: matchedProject?.ProjectName || null,
//         ProjectId: matchedProject?.ProjectId || null,
//         OpeningYear: openingYear,
//       });
//     }
//   }, [CurrentUser, projectId]);
//   return (
//     <SessionContext.Provider
//       value={{ session, setSession, loading, setLoading }}
//     >
//       {children}
//     </SessionContext.Provider>
//   );
// };

// export const useSession = () => {
//   const ctx = useContext(SessionContext);
//   if (!ctx) {
//     throw new Error("useSession must be used within a SessionProvider");
//   }
//   return ctx;
// };

// export { SessionContext };
// SessionProvider.propTypes = {
//   children: PropTypes.node.isRequired,
// };
